var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeWidth: 60,
    stroke: "rgba(114, 78, 247, 0)",
    r: 28,
    cy: 50,
    cx: 50
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 7,
    stroke: "#724ef7",
    r: 28,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keyTimes: "0;0.5;1",
    values: "0 50 50;180 50 50;720 50 50",
    dur: "1s",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    keyTimes: "0;0.5;1",
    values: "80.92742675647307 95.00176184455535;80.92742675647307 95.00176184455535;80.92742675647307 95.00176184455535",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "stroke-dasharray"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderImg);
export default __webpack_public_path__ + "static/media/loaderImg.20c6a7d9751d5fb61c93d6ce2f785abe.svg";
export { ForwardRef as ReactComponent };